// 🎧 AirPods 데이터 (기존 원본 구조와 정확히 일치)
// [배경] 기존 wearables.ts와 동일한 순서와 이름으로 정렬

export interface AirPodsModelData {
  name: string;
  image: string;
  recommended?: boolean;
  modelNumbers?: string[];
  subModels?: {
    modelNumber: string;
    displayName: string;
    connectivity?: string;
    color?: string;
  }[];
}

export const AIRPODS_MODELS: AirPodsModelData[] = [
  { 
    name: 'AirPods 1세대', 
    image: '/assets/airPot/에어팟2세대(유선).png', 
    recommended: true,
    modelNumbers: ['A1523', 'A1722'],
    subModels: [
      { modelNumber: 'A1523', displayName: 'AirPods 1세대', color: '화이트' },
      { modelNumber: 'A1722', displayName: 'AirPods 1세대', color: '화이트' }
    ]
  },
  { 
    name: 'AirPods 2세대', 
    image: '/assets/airPot/에어팟2세대(무선).png', 
    recommended: true,
    modelNumbers: ['A2031', 'A2032', 'A1602', 'A1938'],
    subModels: [
      { modelNumber: 'A2031', displayName: 'AirPods 2세대 ', connectivity: '유선 충전', color: '화이트' },
      { modelNumber: 'A2032', displayName: 'AirPods 2세대 ', connectivity: '유선 충전', color: '화이트' },
      { modelNumber: 'A1602', displayName: 'AirPods 2세대 ', connectivity: '무선 충전', color: '화이트' },
      { modelNumber: 'A1938', displayName: 'AirPods 2세대 ', connectivity: '무선 충전', color: '화이트' }
    ]
  },
  { 
    name: 'AirPods 3세대', 
    image: '/assets/airPot/에어팟3세대.png', 
    recommended: true,
    modelNumbers: ['A2564', 'A2565', 'A2566'],
    subModels: [
      { modelNumber: 'A2564', displayName: 'AirPods 3세대 ', connectivity: 'Lightning', color: '화이트' },
      { modelNumber: 'A2565', displayName: 'AirPods 3세대 ', connectivity: 'Lightning', color: '화이트' },
      { modelNumber: 'A2566', displayName: 'AirPods 3세대 ', connectivity: 'MagSafe', color: '화이트' }
    ]
  },
  { 
    name: 'AirPods 4세대', 
    image: '/assets/airPot/에어팟3세대.png',
    recommended: true,
    modelNumbers: ['A3058', 'A3059', 'A3130'],
    subModels: [
      { modelNumber: 'A3058', displayName: 'AirPods 4세대 ', connectivity: 'USB-C', color: '화이트' },
      { modelNumber: 'A3059', displayName: 'AirPods 4세대 ', connectivity: 'USB-C', color: '화이트' },
      { modelNumber: 'A3130', displayName: 'AirPods 4세대 (케이스)', connectivity: 'USB-C', color: '화이트' }
    ]
  },
  { 
    name: 'AirPods 4세대 ANC', 
    image: '/assets/airPot/에어팟3세대.png',
    recommended: true,
    modelNumbers: ['A3047', 'A3048', 'A3131'],
    subModels: [
      { modelNumber: 'A3047', displayName: 'AirPods 4세대 ANC ', connectivity: 'USB-C', color: '화이트' },
      { modelNumber: 'A3048', displayName: 'AirPods 4세대 ANC ', connectivity: 'USB-C', color: '화이트' },
      { modelNumber: 'A3131', displayName: 'AirPods 4세대 ANC (케이스)', connectivity: 'USB-C', color: '화이트' }
    ]
  },
  { 
    name: 'AirPods Pro 1세대', 
    image: '/assets/airPot/에어팟프로1세대.png', 
    recommended: true,
    modelNumbers: ['A2084', 'A2083', 'A2190'],
    subModels: [
      { modelNumber: 'A2084', displayName: 'AirPods Pro 1세대 ', connectivity: 'Lightning', color: '화이트' },
      { modelNumber: 'A2083', displayName: 'AirPods Pro 1세대 ', connectivity: 'Lightning', color: '화이트' },
      { modelNumber: 'A2190', displayName: 'AirPods Pro 1세대 ', connectivity: 'Lightning', color: '화이트' }
    ]
  },
  { 
    name: 'AirPods Pro 2세대', 
    image: '/assets/airPot/에어팟프로2세대.png', 
    recommended: true,
    modelNumbers: ['A2931', 'A2698', 'A2699', 'A2700', 'A3048', 'A2968'],
    subModels: [
      { modelNumber: 'A2931', displayName: 'AirPods Pro 2세대 ', connectivity: 'Lightning' },
      { modelNumber: 'A2698', displayName: 'AirPods Pro 2세대 ', connectivity: 'USB-C' },
      { modelNumber: 'A2699', displayName: 'AirPods Pro 2세대 ', connectivity: 'Lightning' },
      { modelNumber: 'A2700', displayName: 'AirPods Pro 2세대 ', connectivity: 'Lightning' }
    ]
  },
  { 
    name: 'AirPods Max', 
    image: '/assets/airPot/에어팟맥스.png', 
    recommended: true,
    modelNumbers: ['A2096'],
    subModels: [
      { modelNumber: 'A2096', displayName: 'AirPods Max 스페이스 그레이', connectivity: 'Lightning', color: '스페이스 그레이' },
      { modelNumber: 'A2096', displayName: 'AirPods Max 실버', connectivity: 'Lightning', color: '실버' },
      { modelNumber: 'A2096', displayName: 'AirPods Max 스카이 블루', connectivity: 'Lightning', color: '스카이 블루' },
      { modelNumber: 'A2096', displayName: 'AirPods Max 그린', connectivity: 'Lightning', color: '그린' },
      { modelNumber: 'A2096', displayName: 'AirPods Max 핑크', connectivity: 'Lightning', color: '핑크' }
    ]
  }
];
